import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Skeleton, Table } from '@mantine/core';
import { useShallow } from 'zustand/react/shallow';

import { useDocUploadStore } from '../store';

import styles from './aiExplanation.module.scss';

export const AiExplanation = ({ fileId }: { fileId: string }) => {
  const { t } = useTranslation();

  const { aiExtractionExplanations, metadataInfo, fileState } =
    useDocUploadStore(
      useShallow((state) => {
        return {
          aiExtractionExplanations: state.aiExtractionExplanations[fileId],
          metadataInfo: state.metadataInfo,
          fileState: state.fileState,
        };
      })
    );

  const isFileStateFetchingMetadata = useMemo(
    () =>
      fileState.find((state) => state.id === fileId)?.uploadState ===
      'isFetchingMetadata',
    [fileState, fileId]
  );

  const filteredMetaDataInfo = useMemo(() => {
    return metadataInfo.filter((info) => info.perFileInputInUpload);
  }, [metadataInfo]);

  return (
    <div>
      <h3>{t('app.upload.documentPreview.aiExtractionExplanation')}</h3>
      <Table
        variant="vertical"
        unstyled
        classNames={{ th: styles['th'], td: styles['td'] }}
      >
        <Table.Tbody>
          {filteredMetaDataInfo.map((info) => (
            <Table.Tr key={info.key}>
              <Table.Th>{info.label ?? info.key}</Table.Th>
              <Table.Td>
                <Skeleton visible={isFileStateFetchingMetadata} width="100%">
                  {aiExtractionExplanations?.[info.key] ?? '--'}
                </Skeleton>
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </div>
  );
};
